export class UsuarioFilterItemMarca {
    id: number;
    nome: string;
    selected: boolean;

    constructor(id: number, nome: string) {
        this.id = id;
        this.nome = nome;
    }
}
